<div class="breadcrumbs_section">
    <div class="breadcrumbs_title ">
        <h1 class="breadcrumbcss">{{currentPageTitle}}</h1>
    </div>
    <div class="breadcrumbs_path_sec">
        <a class="breadcrumblink">
            <img src="../../../assets/img/home.png" class="mr-1" alt="Home">
        </a>
        <a *ngFor="let bread of breadcrumbs;let i=index" class="breadcrumblink" [routerLink]="[bread.route]">
            <span *ngIf="i!=0" class="breadcrumb_icon">/</span>
            <span>{{bread.title}}</span>
        </a>
    </div>

</div>